import { forwardRef } from 'react';
import { Card as MuiCard, type CardProps } from '@mui/material';

const Card = forwardRef<HTMLDivElement, CardProps>((props, ref) => (
  <MuiCard ref={ref} {...props} />
));

export default Card;
